import React from 'react';
import { Truck, Building, CreditCard } from 'lucide-react';

const ServicesAndBrands = () => {
  const services = [
    {
      title: "Wholesale",
      icon: <Building className="w-12 h-12 text-green-600" />,
      description: "With warehouses based all over Australia, Sol Mart can distribute Solar PV components, electrical cables & consumables anywhere in the country. Our wholesale products come with a High-Performance Warranty and are highly recommended by industry leaders."
    },
    {
      title: "Freight",
      icon: <Truck className="w-12 h-12 text-green-600" />,
      description: "Sol Mart's freight services deliver all over Australia so you can sit back and relax as you await your stock. We even offer same day delivery depending on your location."
    },
    {
      title: "STC Trading",
      icon: <CreditCard className="w-12 h-12 text-green-600" />,
      description: "You can now trade your STCs with us digitally, benefiting from our streamlined Solar Panel Validation (SPV) process. We utilize a trusted platform to simplify the SPV application, allowing you to trade your STCs with ease. With just a few quick clicks from your phone, you can complete your transactions efficiently and stress-free."
    }
  ];

  const brands = [
    { id: 1, name: "Brand 1", logo: "/api/placeholder/180/60" },
    { id: 2, name: "Brand 2", logo: "/api/placeholder/180/60" },
    { id: 3, name: "Brand 3", logo: "/api/placeholder/180/60" },
    { id: 4, name: "Brand 4", logo: "/api/placeholder/180/60" },
    { id: 5, name: "Brand 5", logo: "/api/placeholder/180/60" },
    { id: 6, name: "Brand 6", logo: "/api/placeholder/180/60" }
  ];

  return (
    <>
      {/* Services Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">OUR SERVICES</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Solmart is a rapidly expanding nation wide wholesaler specializing in a broad spectrum of renewable energy and energy efficiency products.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div 
                key={index}
                className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300"
              >
                <div className="flex flex-col items-center text-center">
                  <div className="mb-4 p-3 bg-green-50 rounded-full">
                    {service.icon}
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">
                    {service.title}
                  </h3>
                  <p className="text-gray-600">
                    {service.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Brands Section */}
      <section className="py-16 bg-gray-900 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0 bg-gradient-to-br from-green-500 to-green-800"></div>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-white mb-4">BRANDS WE SELL</h2>
            <p className="text-lg text-gray-300">
              We partner with industry-leading manufacturers to bring you the best solar solutions
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
            {brands.map((brand) => (
              <div 
                key={brand.id}
                className="bg-white rounded-lg p-6 flex items-center justify-center transform hover:scale-105 transition-transform duration-300"
              >
                <img
                  src={brand.logo}
                  alt={brand.name}
                  className="max-h-12 w-auto"
                />
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <button className="inline-flex items-center px-6 py-3 border-2 border-green-500 text-green-500 hover:bg-green-500 hover:text-white rounded-lg transition-colors duration-300">
              View All Brands
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default ServicesAndBrands;